import { render } from "./ReceiptView.vue?vue&type=template&id=b5bc125a&ts=true"
import script from "./ReceiptView.vue?vue&type=script&lang=ts"
export * from "./ReceiptView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__